var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.143,
    height: 38.143,
    viewBox: "0 0 38.143 38.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ae9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d669"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.143 -315)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.071,
    cy: 19.071,
    r: 19.071,
    transform: "translate(-114.143 315)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-194.598 144.254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.228 188.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1,194.742a.717.717,0,0,1-.79.6h-.3a.717.717,0,0,1-.79-.6V184.325a.717.717,0,0,1,.79-.606h.3a.717.717,0,0,1,.79.606Z",
    transform: "translate(-82.228 -183.719)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.128,194.742a.717.717,0,0,1-.79.6h-.3a.717.717,0,0,1-.79-.6V184.325a.717.717,0,0,1,.79-.606h.3a.717.717,0,0,1,.79.606Z",
    transform: "translate(-73.531 -183.719)",
    fill: "#bcbcbc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.629 170.746)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.993,
    cy: 0.993,
    r: 0.993,
    transform: "translate(1.051)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.95,179.347H85.805l.278-7.872h.538Z",
    transform: "translate(-84.334 -170.482)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.812,182.056a.647.647,0,0,1-.681.6H85.406a.647.647,0,0,1-.681-.6v-5.33a.647.647,0,0,1,.681-.606h2.725a.647.647,0,0,1,.681.606Z",
    transform: "translate(-84.725 -168.8)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.707)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.993,
    cy: 0.993,
    r: 0.993,
    transform: "translate(1.051)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.356,179.347h-1.145l.278-7.872h.538Z",
    transform: "translate(-101.74 -170.482)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.218,182.056a.647.647,0,0,1-.681.6h-2.725a.647.647,0,0,1-.681-.6v-5.33a.647.647,0,0,1,.681-.606h2.725a.647.647,0,0,1,.681.606Z",
    transform: "translate(-102.131 -168.8)",
    fill: "#bcbcbc"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M115.488,186.365c-.285-5.689-7.446-10.245-16.239-10.245s-15.956,4.556-16.241,10.245a1.453,1.453,0,0,0-.011.172v16.31a2.4,2.4,0,0,0,2.637,2.039h27.228a2.4,2.4,0,0,0,2.637-2.039v-16.31A1.453,1.453,0,0,0,115.488,186.365Z",
    transform: "translate(0.278 1.946)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.862,196.583H85.634c-1.456,0-2.637-.586-2.637-1.306v1.369c0,.721,1.181,1.3,2.637,1.3h27.228c1.456,0,2.637-.584,2.637-1.3v-1.369C115.5,196,114.318,196.583,112.862,196.583Z",
    transform: "translate(0.278 8.881)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.328,197.323V188.55c0-.048,0-.1-.007-.143-.214-4.743-5.575-8.541-12.159-8.541s-11.946,3.8-12.16,8.541c0,.048-.007.1-.007.143v8.773Z",
    transform: "translate(1.364 3.302)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.328,197.034v-8.227c0-.045,0-.09-.007-.133-.214-4.448-5.575-8.009-12.159-8.009s-11.946,3.56-12.16,8.009c0,.044-.007.089-.007.133v8.227Z",
    transform: "translate(1.364 3.591)",
    fill: "#3d4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.322,188.674c-.214-4.448-5.575-8.009-12.159-8.009s-11.946,3.56-12.16,8.009c0,.044-.007.089-.007.133v1.817c0-.045,0-.09.007-.133.214-4.448,5.576-8.01,12.16-8.01s11.945,3.562,12.159,8.01c0,.044.007.089.007.133v-1.817C110.328,188.762,110.326,188.717,110.322,188.674Z",
    transform: "translate(1.364 3.591)",
    fill: "#2d353f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2,186.124a1.173,1.173,0,1,1-1.173-1.173A1.174,1.174,0,0,1,91.2,186.124Z",
    transform: "translate(2.4 5.142)",
    fill: "#00d669"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.171 190.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.154,186.124a1.173,1.173,0,1,1-1.174-1.173A1.174,1.174,0,0,1,102.154,186.124Z",
    transform: "translate(-99.807 -184.951)",
    fill: "#00d669"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.981,188.811a.276.276,0,0,0-.285.27,2.9,2.9,0,0,1-.842,1.914,5.015,5.015,0,0,1-2.792.829,4.914,4.914,0,0,1-2.791-.829,2.9,2.9,0,0,1-.842-1.914.277.277,0,1,0-.554.015,3.412,3.412,0,0,0,1.042,2.326,4.819,4.819,0,0,0,3.013.96,5.277,5.277,0,0,0,3.277-.96,3.409,3.409,0,0,0,1.043-2.326A.277.277,0,0,0,99.981,188.811Z",
    transform: "translate(3.493 6.54)",
    fill: "#00d669"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.5eecf1a9fb56472713a1a3a1e6d48a62.svg";
export { ForwardRef as ReactComponent };